// src/HomePage.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';
import { FaClipboardList } from 'react-icons/fa';

// === Flygande fågel ===
function FlyingBird() {
  const [direction, setDirection] = useState('right');
  const [flying, setFlying] = useState(false);
  const [key, setKey] = useState(0);

  useEffect(() => {
    const startDelay = 1000 + Math.random() * 2000;
    const timer = setTimeout(() => setFlying(true), startDelay);
    return () => clearTimeout(timer);
  }, [key]);

  function handleAnimationEnd() {
    setFlying(false);
    setTimeout(() => {
      setDirection((d) => (d === 'right' ? 'left' : 'right'));
      setKey((k) => k + 1);
    }, 1200 + Math.random() * 2500);
  }

  return (
    <img
      src="/bird.png"
      alt="Fågel"
      className={`flying-bird ${direction} ${flying ? 'active' : ''}`}
      onAnimationEnd={handleAnimationEnd}
      draggable={false}
      style={{
        position: 'absolute',
        top: '90px',
        left: 0,
        pointerEvents: 'none',
        zIndex: 4,
        width: 60,
        height: 'auto',
        opacity: flying ? 1 : 0,
        transition: 'opacity 0.25s',
      }}
    />
  );
}

function HomePage() {
  return (
    <div className="home-container">
      {/* Fågeln */}
      <FlyingBird />

      <div className="home-content">
        <h1 className="home-title">Avfalls Appen</h1>

        <p
          style={{
            marginTop: 6,
            marginBottom: 22,
            color: '#6B7280',
            fontSize: 16,
            fontWeight: 400,
            textAlign: 'center',
          }}
        >
          anteckningar och transportdokument för farligt avfall
        </p>

        {/* Enda knappen: login */}
        <Link to="/login">
          <button className="btn-primary home-btn">
            <FaClipboardList className="btn-icon" />
            <span>Logga in</span>
          </button>
        </Link>
      </div>

      <div className="home-decoration">
        <img src="/waves.svg" alt="Vågor" />
        <img className="plant-img" src="/plant.png" alt="Växt" />
      </div>
    </div>
  );
}

export default HomePage;
